import React, { useEffect } from 'react'

import { Box, Switch, Typography } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import WarningIcon from '@material-ui/icons/Warning'
import { Alert } from '@material-ui/lab'

import { getBarringName } from '~/barrings/helpers/barring.helpers'
import useFetchBarring from '~/barrings/useFetchBarring'
import { CustomCircularProgress } from '~/ui/components'

type BarringsProps = {
  subscriptionId: string
}
const Barrings: React.FC<BarringsProps> = ({ subscriptionId }) => {
  const useStyles = makeStyles(() =>
    createStyles({
      formItems: {
        margin: '0',
        padding: '4px 4px 4px 12px;',
        '&': {
          width: '100%',
        },
        '&:first-child:nth-last-child(n+6), &:first-child:nth-last-child(n+6) ~ &': {
          width: '50%',
          '&:nth-child(2n+1)': {
            borderRight: '2px solid #e4e4e4',
          },
          '&:nth-child(1), &:nth-child(2)': {
            paddingTop: '20px',
          },
          '&:last-child, &:nth-child(2n+1):nth-last-child(2)': {
            paddingBottom: '20px',
          },
        },
        '&:first-child:nth-last-child(n-6), &:first-child:nth-last-child(n-6) ~ &': {
          '&:nth-child(1)': {
            paddingTop: '20px',
          },
          '&:last-child': {
            paddingBottom: '20px',
          },
        },
      },
    }),
  )

  const { getBarrings, barrings, loading, error } = useFetchBarring(subscriptionId)

  useEffect(() => {
    if (!barrings) {
      if (subscriptionId) {
        getBarrings(subscriptionId)
      }
    }
  }, [subscriptionId])

  const styles = useStyles()

  return (
    <Box data-hook="subscription-barring-section">
      {loading && (
        <Box mt={2} mb={8}>
          <CustomCircularProgress />
        </Box>
      )}
      {!loading && !error && (
        <Box>
          {barrings &&
            barrings.map((barring) => (
              <FormControlLabel
                className={styles.formItems}
                control={
                  <Switch
                    checked={barring.active}
                    onChange={() => true}
                    name={barring.name}
                    disabled
                  />
                }
                label={
                  <Typography variant="body2" color="textSecondary">
                    {getBarringName(barring)}
                  </Typography>
                }
                key={barring.name}
                data-hook={barring.id}
              />
            ))}
        </Box>
      )}
      {error && (
        <Box mx={4} mb={30} mt={10} data-hook="empty-barrings-alert">
          <Alert severity="error" icon={<WarningIcon fontSize="inherit" />}>
            Error al cargar los datos
          </Alert>
        </Box>
      )}
    </Box>
  )
}
export default Barrings
